module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.e8ecb9f.ttf";